import React from "react";
import { NavLink, Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";

const Header = () => {
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
      <Navbar.Brand as={Link} to="/">
        <h5 className="mb-0">Attikas</h5>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <nav className="navbar-nav me-auto mb-2 mb-lg-0">
          <NavLink to="/">Home</NavLink>
          <NavLink to="/erp" style={{ marginLeft: "10px" }}>
            ERP
          </NavLink>
          <NavLink to="/mtd" style={{ marginLeft: "10px" }}>
            MTD
          </NavLink>
          <NavLink to="/locator" style={{ marginLeft: "10px" }}>
            Locator
          </NavLink>
        </nav>
        <nav className="navbar-nav ms-auto mb-2 mb-lg-0">
          <NavLink to="/about" style={{ marginLeft: "10px" }}>
            About
          </NavLink>
          <NavLink to="https://attikas.com" style={{ marginLeft: "10px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              fill="currentColor"
              className="bi bi-person"
              viewBox="0 0 16 18"
              aria-label="[alttext sighin]"
            >
              <title>Signin</title>
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
            </svg>
          </NavLink>
        </nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
